import { render, staticRenderFns } from "./twoAutorDialog.vue?vue&type=template&id=66b84898&scoped=true&"
import script from "./twoAutorDialog.vue?vue&type=script&lang=js&"
export * from "./twoAutorDialog.vue?vue&type=script&lang=js&"
import style0 from "./twoAutorDialog.vue?vue&type=style&index=0&id=66b84898&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b84898",
  null
  
)

export default component.exports